import { useAtomValue } from 'jotai';

import React, { useCallback } from 'react';

import { Header } from '@shared/ui/header';
import { PinForm } from '@features/otp-verification';
import { defaultTheme, ThemeContext } from '@shared/store/context/ThemeContext';
import { dcbAtom } from '@shared/store/slice-atoms';
import { isVariationV4Route, isVariationV5Route } from '@shared/utils/general';
import PinFormV4 from '@features/confirm-pin/ui/components/PinFormV4';
import { useCleanReferrerTillOTP } from '@shared/hooks/useOTPPageIsUsed';
import { useWideLayout } from '@shared/hooks/useWideLayout';
import { HeaderTV } from '@shared/ui/header';
import { SubHeaderTVMenu } from '@shared/ui/header';
import { MainLayoutContainer } from '@shared/ui/main-layout-container';
import { PinFormV5 } from '@features/otp-verification';
import { AR_lang, EN_lang, FR_lang } from '@entities/language';
import { isAg26MarketingVariation } from '@shared/ui/unlock-vuz-banner';
import { APP_THEMES } from '@shared/config/constants/app';
import '@shared/ui/unlock-vuz-banner/styles/LgAg26Landing.css';

const ConfirmPin = () => {
  useCleanReferrerTillOTP();
  const { isTVLayout } = useWideLayout();

  const dcb = useAtomValue(dcbAtom);
  const isV4Route = isVariationV4Route(dcb.variationKey);
  const isV5Route = isVariationV5Route(dcb.variationKey);
  const isLgAg26 = isAg26MarketingVariation();
  const propsInState = dcb.propsInState;

  const languageConfig = propsInState?.languageConfig || (isV5Route || isLgAg26
    ? { availableLanguages: [EN_lang, AR_lang, FR_lang] }
    : undefined);

  const getHeader = useCallback(() => {
    if (isTVLayout) {
      return <HeaderTV />;
    }

    if (!isV4Route) {
      return (
        <Header
          languageConfig={languageConfig}
          logoConfig={propsInState?.logoConfig}
          isWhite={isV5Route || isLgAg26}
        />
      );
    }

    return null;
  }, [isTVLayout, isV4Route, isV5Route, isLgAg26, languageConfig, propsInState?.logoConfig]);

  const theme = isV5Route || isLgAg26 ? { theme: APP_THEMES.WHITE } : defaultTheme;

  return (
    <ThemeContext.Provider value={theme}>
      <div className={isLgAg26 ? 'lg_ag26-otp' : undefined}>
        {getHeader()}
        <MainLayoutContainer>
          <SubHeaderTVMenu logoConfig={propsInState?.logoConfig} isPinForm />
        </MainLayoutContainer>

        {isV4Route ? <PinFormV4 /> : isV5Route || isLgAg26 ? <PinFormV5 /> : <PinForm />}
      </div>
    </ThemeContext.Provider>
  );
};

export { ConfirmPin };
